import { useTranslation } from 'react-i18next';

import { BannerHelper } from '@/components/common/BannerToast';
import WidgetComponent from '@/components/common/WidgetComponent';
import DashboardAlert from '@/components/dashboard/DashboardAlert';
import { WrappedErrorBoundary } from '@/pages/WrappedErrorBoundary';

const MainInfoBlock = () => {
  const { t } = useTranslation();

  return (
    <div className="tw-w-full tw-p-2 lg:tw-p-4 tw-pb-1 tw-flex tw-flex-col tw-gap-4">
      <BannerHelper message={t('HelpBanner/Intro/hint')} />

      {/* Utilisation de CSS Grid */}
      <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-[360px_1fr] tw-gap-5 tw-items-start">
        {/* Colonne fixe pour la vidéo - 360px max */}
        <div className="tw-w-full tw-max-w-[360px] tw-justify-self-center lg:tw-justify-self-start">
          <WidgetComponent botId="018fc899-cdba-40aa-b063-4134e5fc31b0" />
        </div>

        {/* Colonne flexible pour le contenu */}
        <div className="tw-w-full tw-min-w-0">
          {' '}
          {/* min-w-0 pour éviter l'overflow */}
          {/* Titre */}
          <div className="tw-flex">
            <div className="tw-flex tw-items-center tw-gap-2">
              <div className="tw-text-gray-700 tw-text-2xl tw-font-semibold tw-font-['Lexend'] tw-leading-loose">{t('LatestChatBotsQuickAccess/lastNews')}</div>
            </div>
          </div>
          {/* Contenu */}
          <div className="tw-bg-white tw-rounded-lg tw-shadow">
            <div className="tw-p-2 tw-flex tw-justify-center tw-items-center">
              <DashboardAlert />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WrappedErrorBoundary(MainInfoBlock);
